import { AiOverviewCardClickDataCloudEventType } from '~/modules/analytics/datacloudEventTypes/aiOverviewCardClickDataCloudEventType';
import { AiOverviewFeedbackDataCloudEventType } from '~/modules/analytics/datacloudEventTypes/aiOverviewFeedbackDataCloudEventType';
import { AiOverviewSuggestedClickDataCloudEventType } from '~/modules/analytics/datacloudEventTypes/aiOverviewSuggestedClickDataCloudEventType';
import { SearchDataCloudEventType } from '~/modules/analytics/datacloudEventTypes/searchDataCloudEventType';
import { AnalyticsEvent } from '~/modules/services/analyticsService';
import { AiOverviewImpressionDataCloudEventType } from './aiOverviewImpressionDataCloudEventType';
import {
    AiOverviewCollapseDataCloudEventType,
    AiOverviewExpandDataCloudEventType,
    AiOverviewMobileToggleDataCloudEventType,
    AiOverviewRetryDataCloudEventType,
    AiOverviewStreamCompleteDataCloudEventType,
    AiOverviewStreamErrorDataCloudEventType,
} from './aiOverviewInteractionDataCloudEventTypes';
import {
    AppInstallDataCloudEventType,
    CaseStudyDataCloudEventType,
    CompetenciesRowToggleDataCloudEventType,
    DataSheetDataCloudEventType,
    ListingTabSwitchDataCloudEventType,
    PageViewDataCloudEventType,
    ScreenshotDataCloudEventType,
    TestDriveDataCloudEventType,
    TestimonialDataCloudEventType,
    TileClickDataCloudEventType,
    TileViewDataCloudEventType,
    UninstallDataCloudEventType,
    WebinarDataCloudEventType,
    WhitePaperDataCloudEventType,
} from './customDatacloudEventType';
import { DataCloudEventType } from './datacloudEventType';

export class DataCloudEventTypeFactory {
    static dataCloudEvents: DataCloudEventType[] = [
        new SearchDataCloudEventType(),
        new AiOverviewFeedbackDataCloudEventType(),
        new AiOverviewSuggestedClickDataCloudEventType(),
        new AiOverviewCardClickDataCloudEventType(),
        new TileViewDataCloudEventType(),
        new TileClickDataCloudEventType(),
        new PageViewDataCloudEventType(),
        new ScreenshotDataCloudEventType(),
        new ListingTabSwitchDataCloudEventType(),
        new CompetenciesRowToggleDataCloudEventType(),
        new CaseStudyDataCloudEventType(),
        new UninstallDataCloudEventType(),
        new DataSheetDataCloudEventType(),
        new WebinarDataCloudEventType(),
        new TestimonialDataCloudEventType(),
        new AppInstallDataCloudEventType(),
        new WhitePaperDataCloudEventType(),
        new TestDriveDataCloudEventType(),
        new AiOverviewImpressionDataCloudEventType(),
        new AiOverviewStreamCompleteDataCloudEventType(),
        new AiOverviewStreamErrorDataCloudEventType(),
        new AiOverviewCollapseDataCloudEventType(),
        new AiOverviewExpandDataCloudEventType(),
        new AiOverviewMobileToggleDataCloudEventType(),
        new AiOverviewRetryDataCloudEventType(),
    ];

    static getEventType(event: AnalyticsEvent): DataCloudEventType | undefined {
        return this.dataCloudEvents.find((eventType) => eventType.canHandle(event));
    }
}
